<template>
  <b-row>
    <b-col
      v-for="(counter,index) in counters"
      :key="index"
    >
      <counter-item :data-item="counter" />
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import CounterItem from '@/views/Dashboard/Counters/CounterItem.vue'

export default {
  name: 'Counters',
  components: {
    BRow,
    BCol,
    CounterItem,
  },
  computed: {
    counters() {
      return this.$store.getters['dashboard/counters']
    },
  },
}
</script>
